import React from "react";

const SimpleTitle = ({ text, className = "" }) => {
  return (
    <h2
      className={`font-roboto font-bold text-[32px] leading-[100%] tracking-[0%] text-center text-[#333233] ${className}`}
    >
      {text}
    </h2>
  );
};

export default SimpleTitle;
